import script from "./PieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PieChart.vue?vue&type=script&setup=true&lang=js"

import "./PieChart.vue?vue&type=style&index=0&id=7309585f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7309585f"]])

export default __exports__